import { isEmpty, find, filter } from 'lodash'

const initialState = {
  isFetchingSeparatePropertyData: false,

  isFetchingRealEstate: false,
  isFetchingHouseHold: false,
  isFetchingJewelary: false,
  isFetchingVehicles: false,
  isFetchingSavings: false,
  isFetchingChecking: false,
  isFetchingCredit: false,
  isFetchingCash: false,
  isFetchingTaxRefund: false,
  isFetchingLifeInsurance: false,
  isFetchingStocks: false,
  isFetchingRetirements: false,
  isFetchingProfit: false,
  isFetchingAccounts: false,
  isFetchingPartnership: false,
  isFetchingOtherAssets: false,
  isFetchingContinuationAssets: false,
  isFetchingGetDataS: false,

  isFetchingDeleteSeparateAssets: false,
  isFetchingDeleteSeparateDebits: false,


  isFetchingDescriptionData: false,
  descriptionOptions: [],
  isFetchingSecondTableSeparatePropertyData: false,

  isFetchingStudentLoans: false,
  isFetchingTaxes: false,
  isFetchingSupport: false,
  isFetchingLoans: false,
  isFetchingCreditCards: false,
  isFetchingDebts: false,
  isFetchingContinuationDebts: false,


  isFetchingSecondTableDescriptionData: false,

  isGetAllSeparateData: false,

  realEstateS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
    pfdp: '0.0',
    pfdr: '0.0',
  }],

  householdS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  jewelaryS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  vehiclesS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  savingsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  checkingS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  creditS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  cashS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  taxRefundS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  lifeInsuranceS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  stocksS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  retirementsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  profitS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  accountsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  partnershipS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  otherAssetsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  continuationAssetsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  studentLoansS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  taxesS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  supportS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  loansS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  creditCardsS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  debtsS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  continuationDebtsS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],
};

const separatePropertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_POST_SEPARATE_PROPERTY":
      return { ...state, isFetchingSeparatePropertyData: true };
    case "SUCCESS_POST_SEPARATE_PROPERTY":
      return { ...state, isFetchingSeparatePropertyData: false };
    case "ERROR_POST_SEPARATE_PROPERTY":
      return { ...state, isFetchingSeparatePropertyData: false };


    case "REQUEST_SEPARATE_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: true };
    case "SUCCESS_SEPARATE_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: false, realEstateS: action.payload.data };
    case "ERROR_SEPARATE_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: false };

    case "REQUEST_SEPARATE_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: true };
    case "SUCCESS_SEPARATE_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: false, householdS: action.payload.data };
    case "ERROR_SEPARATE_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: false };

    case "REQUEST_SEPARATE_JEWELARY":
      return { ...state, isFetchingJewelary: true };
    case "SUCCESS_SEPARATE_JEWELARY":
      return { ...state, isFetchingJewelary: false, jewelaryS: action.payload.data };
    case "ERROR_SEPARATE_JEWELARY":
      return { ...state, isFetchingJewelary: false };

    case "REQUEST_SEPARATE_VEHICLES":
      return { ...state, isFetchingVehicles: true };
    case "SUCCESS_SEPARATE_VEHICLES":
      return { ...state, isFetchingVehicles: false, vehiclesS: action.payload.data };
    case "ERROR_SEPARATE_VEHICLES":
      return { ...state, isFetchingVehicles: false };

    case "REQUEST_SEPARATE_SAVINGS":
      return { ...state, isFetchingSavings: true };
    case "SUCCESS_SEPARATE_SAVINGS":
      return { ...state, isFetchingSavings: false, savingsS: action.payload.data };
    case "ERROR_SEPARATE_SAVINGS":
      return { ...state, isFetchingSavings: false };

    case "REQUEST_SEPARATE_CHECKING":
      return { ...state, isFetchingChecking: true };
    case "SUCCESS_SEPARATE_CHECKING":
      return { ...state, isFetchingChecking: false, checkingS: action.payload.data };
    case "ERROR_SEPARATE_CHECKING":
      return { ...state, isFetchingChecking: false };

    case "REQUEST_SEPARATE_CREDIT":
      return { ...state, isFetchingCredit: true };
    case "SUCCESS_SEPARATE_CREDIT":
      return { ...state, isFetchingCredit: false, creditS: action.payload.data };
    case "ERROR_SEPARATE_CREDIT":
      return { ...state, isFetchingCredit: false };

    case "REQUEST_SEPARATE_CASH":
      return { ...state, isFetchingCash: true };
    case "SUCCESS_SEPARATE_CASH":
      return { ...state, isFetchingCash: false, cashS: action.payload.data };
    case "ERROR_SEPARATE_CASH":
      return { ...state, isFetchingCash: false };

    case "REQUEST_SEPARATE_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: true };
    case "SUCCESS_SEPARATE_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: false, taxRefundS: action.payload.data };
    case "ERROR_SEPARATE_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: false };

    case "REQUEST_SEPARATE_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: true };
    case "SUCCESS_SEPARATE_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: false, lifeInsuranceS: action.payload.data };
    case "ERROR_SEPARATE_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: false };

    case "REQUEST_SEPARATE_STOCKS":
      return { ...state, isFetchingStocks: true };
    case "SUCCESS_SEPARATE_STOCKS":
      return { ...state, isFetchingStocks: false, stocksS: action.payload.data };
    case "ERROR_SEPARATE_STOCKS":
      return { ...state, isFetchingStocks: false };

    case "REQUEST_SEPARATE_RETIREMENTS":
      return { ...state, isFetchingRetirements: true };
    case "SUCCESS_SEPARATE_RETIREMENTS":
      return { ...state, isFetchingRetirements: false, retirementsS: action.payload.data };
    case "ERROR_SEPARATE_RETIREMENTS":
      return { ...state, isFetchingRetirements: false };

    case "REQUEST_SEPARATE_PROFIT":
      return { ...state, isFetchingProfit: true };
    case "SUCCESS_SEPARATE_PROFIT":
      return { ...state, isFetchingProfit: false, profitS: action.payload.data };
    case "ERROR_SEPARATE_PROFIT":
      return { ...state, isFetchingProfit: false };

    case "REQUEST_SEPARATE_ACCOUNTS":
      return { ...state, isFetchingAccounts: true };
    case "SUCCESS_SEPARATE_ACCOUNTS":
      return { ...state, isFetchingAccounts: false, accountsS: action.payload.data };
    case "ERROR_SEPARATE_ACCOUNTS":
      return { ...state, isFetchingAccounts: false };

    case "REQUEST_SEPARATE_PARTNERSHIP":
      return { ...state, isFetchingPartnership: true };
    case "SUCCESS_SEPARATE_PARTNERSHIP":
      return { ...state, isFetchingPartnership: false, partnershipS: action.payload.data };
    case "ERROR_SEPARATE_PARTNERSHIP":
      return { ...state, isFetchingPartnership: false };

    case "REQUEST_SEPARATE_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: true };
    case "SUCCESS_SEPARATE_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: false, otherAssetsS: action.payload.data };
    case "ERROR_SEPARATE_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: false };

    case "REQUEST_SEPARATE_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: true };
    case "SUCCESS_SEPARATE_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: false, continuationAssetsS: action.payload.data };
    case "ERROR_SEPARATE_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: false };



    case "REQUEST_GET_SEPARATE_PROPERTY":
      return { ...state, isFetchingDescriptionData: true };
    case "SUCCESS_GET_SEPARATE_PROPERTY":
      return { ...state, descriptionOptions: action.payload, isFetchingDescriptionData: false };
    case "ERROR_GET_SEPARATE_PROPERTY":
      return { ...state, isFetchingDescriptionData: false };

    case "REQUEST_POST_SECOND_TABLE_SEPARATE_PROPERTY":
      return { ...state, isFetchingSecondTableSeparatePropertyData: true };
    case "SUCCESS_POST_SECOND_TABLE_SEPARATE_PROPERTY":
      return { ...state, isFetchingSecondTableSeparatePropertyData: false };
    case "ERROR_POST_SECOND_TABLE_SEPARATE_PROPERTY":
      return { ...state, isFetchingSecondTableSeparatePropertyData: false };

    case "REQUEST_SEPARATE_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: true };
    case "SUCCESS_SEPARATE_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: false, studentLoansS: action.payload.data };
    case "ERROR_SEPARATE_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: false };

    case "REQUEST_SEPARATE_TAXES":
      return { ...state, isFetchingTaxes: true };
    case "SUCCESS_SEPARATE_TAXES":
      return { ...state, isFetchingTaxes: false, taxesS: action.payload.data };
    case "ERROR_SEPARATE_TAXES":
      return { ...state, isFetchingTaxes: false };

    case "REQUEST_SEPARATE_SUPPORT":
      return { ...state, isFetchingSupport: true };
    case "SUCCESS_SEPARATE_SUPPORT":
      return { ...state, isFetchingSupport: false, supportS: action.payload.data };
    case "ERROR_SEPARATE_SUPPORT":
      return { ...state, isFetchingSupport: false };

    case "REQUEST_SEPARATE_LOANS":
      return { ...state, isFetchingLoans: true };
    case "SUCCESS_SEPARATE_LOANS":
      return { ...state, isFetchingLoans: false, loansS: action.payload.data };
    case "ERROR_SEPARATE_LOANS":
      return { ...state, isFetchingLoans: false };

    case "REQUEST_SEPARATE_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: true };
    case "SUCCESS_SEPARATE_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: false, creditCardsS: action.payload.data };
    case "ERROR_SEPARATE_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: false };

    case "REQUEST_SEPARATE_DEBTS":
      return { ...state, isFetchingDebts: true };
    case "SUCCESS_SEPARATE_DEBTS":
      return { ...state, isFetchingDebts: false, debtsS: action.payload.data };
    case "ERROR_SEPARATE_DEBTS":
      return { ...state, isFetchingDebts: false };

    case "REQUEST_SEPARATE_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: true };
    case "SUCCESS_SEPARATE_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: false, continuationDebtsS: action.payload.data };
    case "ERROR_SEPARATE_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: false };


    case "REQUEST_GET_SEPARATE_DATA":
      return { ...state,
        isFetchingSeparatePropertyData: false,

  isFetchingRealEstate: false,
  isFetchingHouseHold: false,
  isFetchingJewelary: false,
  isFetchingVehicles: false,
  isFetchingSavings: false,
  isFetchingChecking: false,
  isFetchingCredit: false,
  isFetchingCash: false,
  isFetchingTaxRefund: false,
  isFetchingLifeInsurance: false,
  isFetchingStocks: false,
  isFetchingRetirements: false,
  isFetchingProfit: false,
  isFetchingAccounts: false,
  isFetchingPartnership: false,
  isFetchingOtherAssets: false,
  isFetchingContinuationAssets: false,
  isFetchingGetDataS: true,


  isFetchingDescriptionData: false,
  descriptionOptions: [],
  isFetchingSecondTableSeparatePropertyData: false,

  isFetchingStudentLoans: false,
  isFetchingTaxes: false,
  isFetchingSupport: false,
  isFetchingLoans: false,
  isFetchingCreditCards: false,
  isFetchingDebts: false,
  isFetchingContinuationDebts: false,


  isFetchingSecondTableDescriptionData: false,

  isGetAllSeparateData: false,

  realEstateS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
    pfdp: '0.0',
    pfdr: '0.0',
  }],

  householdS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  jewelaryS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  vehiclesS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  savingsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  checkingS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  creditS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  cashS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  taxRefundS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  lifeInsuranceS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  stocksS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  retirementsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  profitS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  accountsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  partnershipS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  otherAssetsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  continuationAssetsS: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  studentLoansS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  taxesS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  supportS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  loansS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  creditCardsS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  debtsS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  continuationDebtsS: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }] };
    case "SUCCESS_GET_SEPARATE_DATA":
      return {
        ...state, isFetchingGetDataS: false,
        realEstateS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 1 }).data) ? state.realEstateS : find(action.payload.data, { "asset_brief_description_id": 1 }).data,
        householdS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 2 }).data) ? state.householdS : find(action.payload.data, { "asset_brief_description_id": 2 }).data,
        jewelaryS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 3 }).data) ? state.jewelaryS : find(action.payload.data, { "asset_brief_description_id": 3 }).data,
        vehiclesS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 4 }).data) ? state.vehiclesS : find(action.payload.data, { "asset_brief_description_id": 4 }).data,
        savingsS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 5 }).data) ? state.savingsS : find(action.payload.data, { "asset_brief_description_id": 5 }).data,
        checkingS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 6 }).data) ? state.checkingS : find(action.payload.data, { "asset_brief_description_id": 6 }).data,
        creditS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 7 }).data) ? state.creditS : find(action.payload.data, { "asset_brief_description_id": 7 }).data,
        cashS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 8 }).data) ? state.cashS : find(action.payload.data, { "asset_brief_description_id": 8 }).data,
        taxRefundS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 9 }).data) ? state.taxRefundS : find(action.payload.data, { "asset_brief_description_id": 9 }).data,
        lifeInsuranceS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 10 }).data) ? state.lifeInsuranceS : find(action.payload.data, { "asset_brief_description_id": 10 }).data,
        stocksS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 11 }).data) ? state.stocksS : find(action.payload.data, { "asset_brief_description_id": 11 }).data,
        retirementsS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 12 }).data) ? state.retirementsS : find(action.payload.data, { "asset_brief_description_id": 12 }).data,
        profitS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 13 }).data) ? state.profitS : find(action.payload.data, { "asset_brief_description_id": 13 }).data,
        accountsS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 14 }).data) ? state.accountsS : find(action.payload.data, { "asset_brief_description_id": 14 }).data,
        partnershipS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 15 }).data) ? state.partnershipS : find(action.payload.data, { "asset_brief_description_id": 15 }).data,
        otherAssetsS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 16 }).data) ? state.otherAssetsS : find(action.payload.data, { "asset_brief_description_id": 16 }).data,
        continuationAssetsS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 17 }).data) ? state.continuationAssetsS : find(action.payload.data, { "asset_brief_description_id": 17 }).data,
        studentLoansS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 18 }).data) ? state.studentLoansS : find(action.payload.data, { "asset_brief_description_id": 18 }).data,
        taxesS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 19 }).data) ? state.taxesS : find(action.payload.data, { "asset_brief_description_id": 19 }).data,
        supportS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 20 }).data) ? state.supportS : find(action.payload.data, { "asset_brief_description_id": 20 }).data,
        loansS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 21 }).data) ? state.loansS : find(action.payload.data, { "asset_brief_description_id": 21 }).data,
        creditCardsS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 22 }).data) ? state.creditCardsS : find(action.payload.data, { "asset_brief_description_id": 22 }).data,
        debtsS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 23 }).data) ? state.debtsS : find(action.payload.data, { "asset_brief_description_id": 23 }).data,
        continuationDebtsS: isEmpty(find(action.payload.data, { "asset_brief_description_id": 24 }).data) ? state.continuationDebtsS : find(action.payload.data, { "asset_brief_description_id": 24 }).data,
      };
    case "ERROR_GET_SEPARATE_DATA":
      return { ...state, isFetchingGetDataS: false };



      case "REQUEST_DELETE_SEPARATE_ASSETS":
        return { ...state, isFetchingDeleteSeparateAssets: true };
      case "SUCCESS_DELETE_SEPARATE_ASSETS":
        return {
          ...state,
          isFetchingDeleteSeparateAssets: false,

          realEstateS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 1})) ? state.realEstateS : filter(action.payload.data, {asset_brief_description_id: 1}),
          householdS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 2})) ? state.householdS : filter(action.payload.data, {asset_brief_description_id: 2}),
          jewelaryS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 3})) ? state.jewelaryS : filter(action.payload.data, {asset_brief_description_id: 3}),
          vehiclesS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 4})) ? state.vehiclesS : filter(action.payload.data, {asset_brief_description_id: 4}),
          savingsS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 5})) ? state.savingsS : filter(action.payload.data, {asset_brief_description_id: 5}),
          checkingS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 6})) ? state.checkingS : filter(action.payload.data, {asset_brief_description_id: 6}),
          creditS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 7})) ? state.creditS : filter(action.payload.data, {asset_brief_description_id: 7}),
          cashS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 8})) ? state.cashS : filter(action.payload.data, {asset_brief_description_id: 8}),
          taxRefundS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 9})) ? state.taxRefundS : filter(action.payload.data, {asset_brief_description_id: 9}),
          lifeInsuranceS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 10})) ? state.lifeInsuranceS : filter(action.payload.data, {asset_brief_description_id: 10}),
          stocksS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 11})) ? state.stocksS : filter(action.payload.data, {asset_brief_description_id: 11}),
          retirementsS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 12})) ? state.retirementsS : filter(action.payload.data, {asset_brief_description_id: 12}),
          profitS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 13})) ? state.profitS : filter(action.payload.data, {asset_brief_description_id: 13}),
          accountsS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 14})) ? state.accountsS : filter(action.payload.data, {asset_brief_description_id: 14}),
          partnershipS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 15})) ? state.partnershipS : filter(action.payload.data, {asset_brief_description_id: 15}),
          otherAssetsS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 16})) ? state.otherAssetsS : filter(action.payload.data, {asset_brief_description_id: 16}),
        };
        
      case "ERROR_DELETE_SEPARATE_ASSETS":
        return { ...state, isFetchingDeleteSeparateAssets: false };


        case "REQUEST_DELETE_SEPARATE_DEBITS":
        return { ...state, isFetchingDeleteSeparateDebits: true };
      case "SUCCESS_DELETE_SEPARATE_DEBITS":
        return {
          ...state,
          isFetchingDeleteSeparateDebits: false,

          studentLoansS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 18})) ? state.studentLoansS : filter(action.payload.data, {asset_brief_description_id: 18}),
          taxesS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 19})) ? state.taxesS : filter(action.payload.data, {asset_brief_description_id: 19}),
          supportS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 20})) ? state.supportS : filter(action.payload.data, {asset_brief_description_id: 20}),
          loansS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 21})) ? state.loansS : filter(action.payload.data, {asset_brief_description_id: 21}),
          creditCardsS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 22})) ? state.creditCardsS : filter(action.payload.data, {asset_brief_description_id: 22}),
          debtsS: isEmpty(filter(action.payload.data, {asset_brief_description_id: 23})) ? state.debtsS : filter(action.payload.data, {asset_brief_description_id: 23}),
        };
      case "ERROR_DELETE_SEPARATE_DEBITS":
        return { ...state, isFetchingDeleteSeparateDebits: false };


    default:
      return state;
  }
};

export default separatePropertyReducer;
